// ENUM `tipo_uso` del modelo Edificio (API-PROAPP/src/models/EdificioModel.ts).
// Mantener sincronizado con el backend — un cambio en el ENUM requiere tocar
// ambos lados y agregar una migración SQL.
export const TIPO_USO_OPTIONS = [
  { value: 'residencial', label: 'Residencial' },
  { value: 'comercial', label: 'Comercial' },
  { value: 'oficinas', label: 'Oficinas' },
  { value: 'educacion', label: 'Educación' },
  { value: 'salud', label: 'Salud' },
  { value: 'publico', label: 'Público' },
  { value: 'mixto', label: 'Mixto' },
  { value: 'otro', label: 'Otro' },
];

export const TIPO_USO_LABELS = TIPO_USO_OPTIONS.reduce((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});
